module.exports = [
  ...require('./b'),
  ...require('./g'),
  ...require('./l'),
  ...require('./s'),
]
